<template>
  <component :is="tag" :class="{ [openClass]: isExpanded }">
    <div
      v-if="$slots.trigger"
      :aria-controls="expandableId"
      :aria-expanded="isExpanded"
      role="button"
      tabindex="0"
      @click="toggle"
      @keyup.enter="toggle"
    >
      <slot name="trigger" v-bind="{ open: isExpanded }" />
    </div>

    <div
      :id="expandableId"
      class="grid overflow-hidden transition-all duration-300"
      :class="{
        'grid-rows-[1fr]': isExpanded,
        'grid-rows-[0fr]': !isExpanded,
      }"
    >
      <div class="min-h-0">
        <slot />
      </div>
    </div>
  </component>
</template>

<script lang="ts" setup>
const isExpanded = defineModel<boolean>({ default: false });

const properties = withDefaults(
  defineProps<{
    tag?: keyof HTMLElementTagNameMap;
    defaultExpanded?: boolean;
    disabled?: boolean;
    openClass?: string;
  }>(),
  {
    tag: "div",
    openClass: "",
  },
);

defineSlots<{
  trigger(props: { open: boolean }): void;
  default(): void;
}>();

function toggle() {
  if (properties.disabled) return;

  isExpanded.value = !isExpanded.value;
}

const expandableId = useId();

const emit = defineEmits(["close", "expand"]);

watch(isExpanded, (value) => emit(value ? "expand" : "close"));
</script>
